// src/pages/About.js
import React from 'react';
import { Container, Typography, Box, Grid, Button } from '@mui/material';
import { styled } from '@mui/system';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  padding: theme.spacing(4),
  borderRadius: theme.shape.borderRadius,
}));

const About = () => {
  return (
    <Container maxWidth="md">
      <Box my={4}>
        <Typography variant="h4" component="h1" gutterBottom>
          Robert Wilkins III
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6}>
            <img
              src="https://storage.googleapis.com/gcpguide/realcloudarchitect.png"
              alt="Robert Wilkins III"
              width="100%"
              style={{ borderRadius: '50%' }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <StyledBox>
              <Typography variant="body1" paragraph>
                Robert Wilkins III is an experienced cloud architect with a strong background in cloud computing technologies, software engineering, and data management. He has worked with leading organizations to design and implement scalable, secure, and cost-effective cloud solutions.
              </Typography>
              <Typography variant="body1" paragraph>
                Robert's journey as a cloud architect began with a focus on Google Cloud Platform, and he has since expanded his expertise to other cloud providers and technologies. He is passionate about sharing his knowledge and experiences through writing, speaking, and mentoring.
              </Typography>
              <Typography variant="body1" paragraph>
                To learn more about Robert and connect with him, visit his LinkedIn profile:
              </Typography>
              <Button align="center"
  href="https://www.linkedin.com/in/robertwilkinsiii/"
  target="_blank"
  rel="noopener noreferrer"
  variant="contained"
  startIcon={<LinkedInIcon />}
  sx={{
    bgcolor: '#0077B5',
    color: '#fff',
    '&:hover': {
      bgcolor: '#006699',
    },
  }}
>
  Connect on LinkedIn
</Button>
            </StyledBox>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default About;
